module.exports = __webpack_public_path__ + "static/media/Sr. Chinnamma.55d275da.png";